export default (theme) => ({
  graphic: {
    position: 'fixed',
    left: '-180px',
    bottom: '-440px',
    [theme.breakpoints.down('xl')]: {
      left: '-150px',
      width: 612,
    },
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  fullGraphic: {
    opacity: 0.1,
    left: 'initial',
    bottom: 'initial',
    top: 0,
    width: '100%',
    height: '100%',
    transform: 'scale(1.2)',
    [theme.breakpoints.down('xl')]: {
      left: 'initial',
      width: '100%',
      transform: 'scale(1.1)',
    },
    [theme.breakpoints.down('md')]: {
      display: 'block',
      transform: 'scale(1.5)',
    },
    [theme.breakpoints.down('md')]: {
      display: 'block',
      transform: 'scale(1.9)',
    },
  },
  ellipse: {
    stroke: theme.palette.primary.main,
  },
  fullGraphicEllipse: {
    stroke: '#ffffff',
  },
});
